import React from 'react';

import PropTypes from 'prop-types';

export const twitter = ({ fillColor }) => (
    <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 500 500'>
        <g fill={fillColor}>
            <path
                d='M374.2,175.7c0.2,2.6,0.2,5.2,0.2,7.7c0,78.6-59.8,169.2-169.2,169.2c-33.7,0-65-9.8-91.3-26.7c4.8,0.6,9.4,0.7,14.4,0.7
        c27.8,0,53.4-9.4,73.8-25.4c-26.1-0.6-48.1-17.7-55.6-41.2c3.7,0.6,7.4,0.9,11.2,0.9c5.3,0,10.7-0.7,15.6-2
        c-27.2-5.5-47.7-29.5-47.7-58.4c0-0.2,0-0.6,0-0.7c7.9,4.4,17.1,7.2,26.9,7.5c-16-10.7-26.5-28.9-26.5-49.5c0-11,2.9-21.2,8.1-30
        c29.3,36.1,73.3,59.7,122.6,62.2c-0.9-4.4-1.5-9-1.5-13.6c0-32.8,26.5-59.5,59.5-59.5c17.1,0,32.6,7.2,43.5,18.8
        c13.4-2.6,26.3-7.5,37.7-14.4c-4.4,13.8-13.8,25.4-26.1,32.8c12-1.3,23.6-4.6,34.2-9.2C395.9,156.7,385.8,167.2,374.2,175.7z'
            />
        </g>
    </svg>
);

twitter.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default twitter;
